import Sidebar from '../Sidebar/Sidebardigital';
import React, { useState } from 'react';

export default function Leadform() {
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [district, setDistrict] = useState("");
  const [village, setVillage] = useState("");
  const [owner, setOwner] = useState("");
  const [interest, setInterest] = useState("");
  const [discuss, setDiscuss] = useState("");

  // const [error, setError] = useState('');

  const handleOnSubmit = async (e) => {
    e.preventDefault();

    let result = await fetch('https://gatisheelback.azurewebsites.net/register', 
    {
      method: "post",
      body: JSON.stringify({ name, mobile, district, village, owner, interest, discuss }),
      headers: {
        'Content-Type': 'application/json'
          }
        }); 

    // result = await result.json();
    // console.warn(result);
    if (result.ok) {
      alert("Data saved successfully" );
      // Reset form fields after successful submission
      setName("");
      setMobile("");
      setDistrict("");
      setVillage("");
      setOwner("");
      setInterest("");
      setDiscuss("");
    }
    else
{
    alert("Failed to register farmer due to same mobile number OR lead owner is empty");
      // Reset form fields after successful submission
      // setName("");
      // setMobile("");
      // setDistrict("");
      // setVillage("");
      // setOwner("");
      // setInterest("");
      // setDiscuss("");

    }
  
};

  return (
    <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
        <div className="col-8 custom-width">
          <br /><br /><br />
          <h1>Farmer Registration</h1><br />
          <h5>Basic Profile</h5>
          <form>
            <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} /><br /><br />
            <input type="number" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} /><br /><br />
            {/* <input type="text" placeholder="District" value={district} onChange={(e) => setDistrict(e.target.value)} /><br /><br /> */}
            <select value={district} onChange={(e) => setDistrict(e.target.value)}>
              <option value="">Select District</option>
              <option value="Yamunanagar">Yamunanagar</option>
              <option value="Karnal">Karnal</option>
              <option value="Kurukshetra">Kurukshetra</option>
              <option value="Ambala">Ambala</option>
              <option value="Kaithal">Kaithal</option>
              {/* Add more options as needed */}
            </select><br /><br />
            <input type="text" placeholder="Village" value={village} onChange={(e) => setVillage(e.target.value)} /><br /><br />
            <select value={owner} onChange={(e) => setOwner(e.target.value)} required>
              <option value="">Lead Owner  </option>
              <option value="Umesh">Umesh</option>
              <option value="Aman">Aman</option>
              <option value="Ravinder">Ravinder</option>
              {/* Add more options as needed */}
            </select><br /><br />

            <select value={interest} onChange={(e) => setInterest(e.target.value)}>
              <option value="">Interest Level  </option>
              <option value="Very High">Very High</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
              {/* Add more options as needed */}
            </select><br /><br />
            <textarea
              placeholder="Description points"
              value={discuss}
              onChange={(e) => setDiscuss(e.target.value)}
              cols={50}
              rows={8}
            ></textarea><br /><br />
            {/* <input type="text" placeholder="Discussion Points" value={discuss} onChange={(e) => setDiscuss(e.target.value)} /><br /><br /> */}
            <button type="submit" onClick={handleOnSubmit}>Submit</button>
          </form>
          <br /><br />
        </div>
        <div className="col-2 custom-display">
          <Sidebar />
        </div>
      </div>
    </>
  );
};
